import { useQuery } from 'react-query';
import customAxios from '../../../axios/custom-axios';

const getRetrunItemsXls = async (returnId) => {
  const token = localStorage.getItem('token');
  customAxios({
    method: 'get',
    responseType: 'arraybuffer',
    url: `/returns/${returnId}/items/xls`,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `return_${returnId}.xls`);
        document.body.appendChild(link);
        link.click();
      }
    });
};

const useGetRetrunItemsXls = (returnId) => useQuery(['itemsExcelFile', returnId], () => getRetrunItemsXls(returnId), { enabled: false });

export default useGetRetrunItemsXls;
